Handlebars.registerPartial('partials/uitk/action-bar', Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"action-bar\"></div>";
},"useData":true}));